export const createUserScopedStorage = <T>(storageKey: string) => {
  return (userKey: string) => ({
    get: (): T | null => {
      const stored = localStorage.getItem(storageKey);
      if (!stored) return null;

      try {
        const parsed = JSON.parse(stored);
        return parsed[userKey] || null;
      } catch {
        return null;
      }
    },
    set: (value: T) => {
      const stored = localStorage.getItem(storageKey);
      const existing = stored ? JSON.parse(stored) : {};

      localStorage.setItem(
        storageKey,
        JSON.stringify({
          ...existing,
          [userKey]: value,
        }),
      );
    },
  });
};
